// import b1 from './image/book-1.png'


export const Data = [
  {
    "imageLink": "image/book-1.png",
    "pages": 209,
    "title": "The Art City",
    "year": 1999,
    "category": "Story"
  },
  {
    "imageLink": "image/book-2.png",
    "pages": 250,
    "title": "Give Thanks In Everything Happy",
    "year": 2000,
    "category": "Story"
  },
  {
    "imageLink": "image/book-3.png",
    "pages": 729,
    "title": "Your Name",
    "year": 2005,
    "category": "Mistery"
  },
  {
    "imageLink": "image/book-4.png",
    "pages": 100,
    "title": "Your Title",
    "year": 2017,
    "category": "Mistery"
  },
  {
    "imageLink": "image/book-5.png",
    "pages": 1921,
    "title": "Music Rock",
    "year": 2021,
    "category": "Novel"
  },
  {
    "imageLink": "image/book-6.png",
    "pages": 209,
    "title": "Things Fall Apart",
    "year": 2003,
    "category": "Horror"
  },
  {
    "imageLink": "image/book-7.png",
    "pages": 309,
    "title": "Art Behind",
    "year": 2005,
    "category": "Novel"
  },
  {
    "imageLink": "image/book-8.png",
    "pages": 410,
    "title": "Black History",
    "year": 2015,
    "category": "History"
  },
  {
    "imageLink": "image/book-9.png",
    "pages": 1000,
    "title": "Love",
    "year": 2023,
    "category": "Romance"
  },
  {
    "imageLink": "image/book-10.png",
    "pages": 1433,
    "title": "Retro",
    "year": 2017,
    "category": "Action"
  }
]